import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/style.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { getRequest } from "@/api/api";

Vue.prototype.getRequest = getRequest;
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
